import Icon from '../components/Icon.vue'

Icon.register({
  users: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M96 224C131.3 224 160 195.3 160 160S131.3 96 96 96 32 124.7 32 160 60.7 224 96 224zM544 224C579.3 224 608 195.3 608 160S579.3 96 544 96 480 124.7 480 160 508.7 224 544 224zM576 256H512C494.4 256 478.5 263.1 466.9 274.6 507.2 296.7 535.8 336.6 542 384H608C625.7 384 640 369.7 640 352V320C640 284.7 611.3 256 576 256zM320 256C381.9 256 432 205.9 432 144S381.9 32 320 32 208 82.1 208 144 258.1 256 320 256zM396.8 288H388.5C367.7 298 344.6 304 320 304S272.4 298 251.5 288H243.2C179.6 288 128 339.6 128 403.2V432C128 458.5 149.5 480 176 480H464C490.5 480 512 458.5 512 432V403.2C512 339.6 460.4 288 396.8 288zM173.1 274.6C161.5 263.1 145.6 256 128 256H64C28.7 256 0 284.7 0 320V352C0 369.7 14.3 384 32 384H97.9C104.2 336.6 132.8 296.7 173.1 274.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/users.js
// module id = bXQA
// module chunks = 144